module.exports = __webpack_public_path__ + "img/cash.d42ce923.jpeg";